var $body = $('.js-body'),
	$main = $('.js-main'),
	$mainHeader = $('.js-main-header'),
	$mainNav = $('.js-main-nav'),
	$mainMenu = $('.js-main-menu'),
	$cookie = $('js-cookie'),
	$window = $(window),
	wh = $window.height(),
	ww = $window.width(),
	st = $window.scrollTop(),
	wb = st + wh,
	hash = window.location.hash.replace('#', ''),
	bgVideoInit = false,
	sm = 600,
	md = 900,
	lg = 1200,
	xl = 1800,
	windowScroll = st;

	// flag to allow clicking
    var isResponsive = true;

function updateResize() {
	wh = $window.height();
	ww = $window.width();
}

function updateScroll() {
	st = $window.scrollTop();
	sb = st + wh;
}


$(function(){
	$window.on('scroll', function(){
		updateScroll();
	});
});